import React, { useEffect, useState, useRef } from 'react';
import { Box, Button, Grid, Dialog, DialogContent } from "@mui/material";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { setHeaderName, setSelectedIndex } from "../../redux/actions/userActions";
import CustomDialog from "../commoncomponents/CustomDialog";
import Axios from 'axios';
import { DefaultCard } from "../../assets/styled-components/card";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import PageTitle from "../commoncomponents/PageTitle";
import { MasterGraph, FemsGraph, BemsGraph } from "../../utility/apiURLS";
import Contractdownloadform from '../contractreportcomponents/Contractdownloadform';
import { useAccess } from "../../AccessContext";
import utilities from '../../utility/utilities';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import * as XLSX from 'xlsx';
import DownloadIcon from '@mui/icons-material/Download';
import PageLoader from "../commoncomponents/PageLoader";
import { getAuthToken, getcompanyId, getFacilityId ,getuserId} from "../../utility/tokenUtility";

const Contractviewform = () => {
    const navigate = useNavigate();
    const token = getAuthToken("id_token");
   
    const [service, setService] = useState({
        value: "FEMS",
        label: "FEMS",
        id: "2f702577-5b94-4975-9367-e1b3721f6e7a"
    });
    const [serviceOptions, setServiceOptions] = useState([]);

    const [contractTypeOption, setContractTypeOption] = useState([]);
    const [contracttype, setContractType] = useState({
        value: 0,
        label: "All"
    });
    const [contractReport, setContractReport] = useState({
        value: 1,
        label: "Contract out register detail report"
    });
    const [level, setLevel] = useState({
        value: 1,
        label: "Hospital"
    });

    const [isLoading, setIsLoading] = useState(false);
    const [reportdata, setReportdata] = useState([]);
    const [errors, setErrors] = useState({});
    const [errorMessages, setErrorMessages] = useState({});
    const [year, setYear] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [hospitalnameOptions, setHospitalnameOptions] = useState([]);
   const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
    const STATUS_ALL = { label: "All", value: 0 };
    const STATUS_ACTIVE = { label: "Active", value: 1 };
    const STATUS_INACTIVE = { label: "Inactive", value: 2 };
    const STATUS_Expired = { label: "Expired", value: 3 };
    const [status, setStatus] = useState(STATUS_ALL);
    const dispatch = useDispatch();
    const [isView, setIsView] = useState(false);
    const childRef = useRef(null);
    const config = {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    };
    const facilityId = localStorage.getItem('facilityId');
    const companyId = localStorage.getItem('companyId');

    const accessData = useAccess();
    const access = utilities.getScreenPermissions(accessData, "ENGA008");
    const handleLevel = (newValue) => {
        
    
        setLevel(newValue);
    
        // Ensure we handle `value: 0` correctly
        if (newValue && typeof newValue === "object" && "value" in newValue && newValue.value !== undefined) {
            setErrors((prevErrors) => ({ ...prevErrors, level: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, level: "" }));
        } else {
            setErrors((prevErrors) => ({ ...prevErrors, level: true }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, level: "Level is Required" }));
        }
    };
    


    const handleContractReport = (newValue) => {
        setContractReport(newValue);
        if (newValue && newValue.value) {
            setErrors((prevErrors) => ({ ...prevErrors, contractReport: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, contractReport: "" }));
        } else {
            setErrors((prevErrors) => ({ ...prevErrors, contractReport: true }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, contractReport: "Contract Report is required" }));
        }
    };

    const handleContractTypeChange = (newValue) => {
        setContractType(newValue);
        if (newValue) {
            setErrors((prevErrors) => ({ ...prevErrors, contracttype: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, contracttype: "" }));
        }
    };

    const handleServiceChange = (newValue) => {
       
        if (newValue.label) {
            setService(newValue);
            setErrors((prevErrors) => ({ ...prevErrors, service: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, service: "" }));
        } else {
            setService({ label: '', value: '' });
        }
    };


    const handleStatusChange = (selectedOption) => {
        if (selectedOption && selectedOption.value !== undefined) {
            setStatus(selectedOption);
            setErrors((prevErrors) => ({ ...prevErrors, status: false }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, status: "" }));
        } else {
            setErrors((prevErrors) => ({ ...prevErrors, status: true }));
            setErrorMessages((prevMessages) => ({ ...prevMessages, status: "Invalid selection" }));
        }
    };


    const fetchServiceOptions = async () => {
        try {
            const response = await Axios.get(`${MasterGraph}/api/masservicedetails`, config);
            const filteredOptions = response.data.filter(option => option.service);
            setServiceOptions(filteredOptions.map(option => ({
                label: option.service,
                value: option.service,
                id: option.id
            })));
            console.log(serviceOptions, "filteredOptions");
        } catch (error) {
            console.error("Error fetching service options:", error);
        }
    };

    const fetchContractTypes = async () => {
        try {
            const response = await Axios.get(`${FemsGraph}/api/femcontracttypes`);
            const contractTypesData = response.data;
            const contractTypes = contractTypesData.map((type) => ({
                value: type.id,
                label: type.contracttype,
            }));

            const allOption = { value: 0, label: 'All' };
            setContractTypeOption([allOption, ...contractTypes]);

        } catch (error) {
            console.error('Error fetching contract types:', error);
        }
    };



    const fetchReportdata = async () => {
        setIsLoading(true);
        try {
            const facilityId = localStorage.getItem('facilityId');
            const companyId = getcompanyId('companyId');
            const userId = getuserId('UserId');

            if (!facilityId) {
                console.error();
                return;
            }

            const payload = {
                facilityid: facilityId,
                contractTypeid: contracttype.value,
                // isactive: status === STATUS_ACTIVE ? true : (status === STATUS_INACTIVE ? false : null),
               // isactive: status?.value === true ? true : status?.value === false ? false : null,
                isactive: status.value === STATUS_ACTIVE.value ? 1 : (status.value === STATUS_INACTIVE.value ? 2 : (status.value === STATUS_Expired.value ? 3 : 0)),
                report: contractReport?.value || "",
                tokens:token,
                companyid:companyId ,
                userid:userId,
                level:level.value,
              

            };
            
            let response;

            if (service.label === "FEMS") {
                console.log("Fetching FEMS data");
                response = await Axios.post(`${FemsGraph}/api/GraphContractReport/ContractReportListfem`, payload, config);
            } else if (service.label === "BEMS") {
                console.log("Fetching BEMS data");
                response = await Axios.post(`${BemsGraph}/api/GraphContractReport/ContractReportListbem`, payload, config);
            }


            const reportdata = Array.isArray(response.data) ? response.data : [response.data];



            setReportdata(reportdata);


        } catch (error) {
            console.error("Error fetching report data:", error);
        }
        finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchServiceOptions();
        fetchContractTypes();
        fetchReportdata();
    }, []);


    const handleView = async () => {
        setIsView(true);
        if (!service.label ||!level.label|| !contracttype.label || status === undefined || !contractReport?.value) {
            setErrors({
                level:!level?.label,
                service: !service.label,
                contracttype: !contracttype.label,
                status: status === undefined,
                contractReport: !contractReport?.value,
            });
            setErrorMessages({
                level:!level.label? "Label is Required" : "",
                service: !service.label ? "Service is required" : "",
                contracttype: !contracttype.label ? "Contract Type is required" : "",
                status: status === undefined ? "Status is required" : "",
                contractReport: !contractReport?.value ? "Contract Report is required" : "",
            });
            return;
        }

        try {
            await fetchReportdata();
            setOpenModal(true);
        } catch (error) {
            console.error("Error fetching report data:", error);
        }
    };


    const handleCancelConfirm = () => {
        setCancelDialogOpen(false);
        navigate("/dashboard");
        dispatch(setSelectedIndex('SET_INDEX_LABEL', ''));
        dispatch(setHeaderName('SET_HEADER_NAME', 'Dashboard'));
    };
    const handleCancelDialogClose = () => {
        setCancelDialogOpen(false);
    };

    const handleCancel = () => {
        if (!service.label) {
            navigate("/dashboard");
            dispatch(setSelectedIndex('SET_INDEX_LABEL', ''));
            dispatch(setHeaderName('SET_HEADER_NAME', 'Dashboard'));
        } else {
            setCancelDialogOpen(true);
        }

    };


    const handleDownload = async () => {
        if (!service.label ||!level.label|| !contracttype.label || status === undefined || !contractReport?.value) {
            setErrors({
                level:!level?.label,
                service: !service.label,
                contracttype: !contracttype.label,
                status: status === undefined,
                contractReport: !contractReport?.value,
            });
            setErrorMessages({
                   level:!level.label? "Label is required" : "",
                service: !service.label ? "Service is required" : "",
                contracttype: !contracttype.label ? "Contract Type is required" : "",
                status: status === undefined ? "Status is required" : "",
                contractReport: !contractReport?.value ? "Contract Report is required" : "",
            });
            return;
        }
        await fetchReportdata();
        setIsView(false);
        setOpenModal(true);


        setTimeout(() => {
            if (childRef.current) {
                childRef.current.handleDownloadPDF();
            }

            setTimeout(() => {
                setOpenModal(false);
            }, 1000);
        }, 500);


    };
    const handleExcel = async () => {
        if (!service.label ||!level.label|| !contracttype.label || status === undefined || !contractReport?.value) {
            setErrors({
                 level:!level?.label,
                service: !service.label,
                contracttype: !contracttype.label,
                status: status === undefined,
                contractReport: !contractReport?.value,
            });
            setErrorMessages({
                level:!level.label? "Label is required" : "",
                service: !service.label ? "Service is required" : "",
                contracttype: !contracttype.label ? "Contract Type is required" : "",
                status: status === undefined ? "Status is required" : "",
                contractReport: !contractReport?.value ? "Contract Report is required" : "",
            });
            return;
        }
        try {
     
            await fetchReportdata();
            setIsView(false);
            setOpenModal(true);

        setTimeout(() => {
            if (childRef.current) {
                childRef.current.handleExcel();
            }

            setTimeout(() => {
                setOpenModal(false);
            }, 1000);
        }, 500);
    } catch (error) {
        console.error("Error fetching report data:", error);
    } 


    };
  

    return (
        <>
            <PageLoader open={isLoading} />
            <PageTitle title={"Contract Out Register Report"} />

            <Box mt={{ xs: 1, sm: 2 }}>
                <DefaultCard>
                    <Grid container spacing={2}>
                    <Grid item xs={6} md={4}>
                            <CustomSelectInput
                                label="Level"
                                id="level"
                                autoFocus={true}
                                value={level}
                                options={[
                                    { label: "Hospital", value: 1 },
                                    { label: "HQ", value: 0 },
                                ]}
                                onChange={handleLevel}
                                isMandatoryField={true}
                                error={errors.level}
                                errorMessage={errorMessages.level}
                                disableClearable={true}
                            />
                             </Grid>
                        <Grid item xs={6} md={4}>
                            <CustomSelectInput
                                label="Contract Report"
                                id="contractReport"
                                autoFocus={true}
                                value={contractReport}
                                options={[
                                    { label: "Contract out register detail report", value: 1 },
                                    { label: "Contract out register summary report", value: 2 },
                                ]}
                                onChange={handleContractReport}
                                isMandatoryField={true}
                                error={errors.contractReport}
                                errorMessage={errorMessages.contractReport}
                                disableClearable={true}
                            />



                        </Grid>
                        <Grid item xs={6} md={4}>
                            <CustomSelectInput
                                id="service-label"
                                label="Service"
                                value={service}
                                options={serviceOptions}
                                onChange={handleServiceChange}
                                isMandatoryField={true}
                                error={errors.service}
                                errorMessage={errorMessages.service}
                                disableClearable={true}

                            />
                        </Grid>
                        <Grid item xs={6} md={4}>
                            <CustomSelectInput
                                error={errors.contracttype}
                                disableClearable={true}
                                label="Contract Type"
                                options={contractTypeOption}
                                value={contracttype || null}
                                onChange={handleContractTypeChange}
                                id="contracttype"
                                helperText={errorMessages.contracttype}
                                errorMessage={errorMessages.contracttype}
                            />
                        </Grid>

                        <Grid item xs={6} md={4}>
                            <CustomSelectInput
                                label="Status"
                                name="status"
                                id="status"
                                value={status} // Set status directly as the value
                                options={[
                                    { value: STATUS_ALL.value, label: STATUS_ALL.label }, // "All"
                                    { value: STATUS_ACTIVE.value, label: STATUS_ACTIVE.label }, // "Active"
                                    { value: STATUS_INACTIVE.value, label: STATUS_INACTIVE.label }, // "Inactive"
                                    { value: STATUS_Expired.value, label: STATUS_Expired.label }, // "Expired"
                                ]}
                                onChange={handleStatusChange} // Handle the change
                                isMandatoryField={true}
                                error={errors?.status}
                                helperText={errorMessages?.status} // use helperText instead of errorMessage
                                disableClearable={true}
                            />



                        </Grid>




                    </Grid>
                    <Box
                        sx={{
                            display: "flex",
                            gap: 2,
                            justifyContent: { xs: "center", md: "end" },
                            mt: 3,
                        }}
                    >
                        <Button variant='contained' onClick={handleView}>View</Button>
                     {/* <Button variant='contained'
                         startIcon={<DownloadIcon />}  
                         style={{ marginRight: '8px' }} onClick={handleDownload}>PDF</Button> */}
                          {access?.canPrint &&  <Button variant='contained' onClick={handleExcel}
                        startIcon={<InsertDriveFileIcon />} 
                        style={{ marginRight: '8px' }}>XLSX</Button>}
                        <Button variant='outlined' onClick={handleCancel}>Close</Button>
                    </Box>
                </DefaultCard>
                <Dialog
                    open={openModal}
                    onClose={() => setOpenModal(false)}
                    maxWidth={false}
                    fullWidth
                    sx={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        overflow: "auto",
                        ...(!isView && {
                            "& .MuiBackdrop-root": {
                                backgroundColor: "transparent",
                            },
                            top: "-9999px",
                            left: "-9999px",
                            zIndex: "-1",
                        }),
                    }}
                >

                    <DialogContent>
                        <Contractdownloadform
                            reportdata={reportdata}
                            setOpenModal={setOpenModal}
                            service={service}
                            level={level?.value}
                            contractReport={contractReport}
                            ref={childRef}

                        />
                    </DialogContent>
                </Dialog>
            </Box>
            <CustomDialog
                open={cancelDialogOpen}
                onClose={handleCancelDialogClose}
                onConfirm={handleCancelConfirm}
                title="Cancel Confirmation"
                content="Do you want to continue?"
                cancelBtn="No"
                confirmBtn="Yes"
            />
        </>
    );
};

export default Contractviewform


